export default {
  endpoint: process.env.REACT_APP_BACKEND_URL ?? 'https://jenkins.temera.it/otb-tmr-api/', //staging
  // endpoint: process.env.REACT_APP_BACKEND_URL ?? 'https://otb-quality.temera.it/otb-tmr-api', //quality
  // endpoint: process.env.REACT_APP_BACKEND_URL ?? 'https://otb.temera.it/otb-tmr-api/', //prod
}
